<template>
  <article id="about" class="layout-section -split -reverse">
    <figure
      v-appear:left
      class="layout-section__figure -reverse"
      :style="{ '--image': `url('/images/about-mission.jpg')` }"
    />

    <section class="layout-section__content">
      <div class="layout-section__hgroup">
        <h2 v-appear:right="{ delay: 100 }" class="layout-section__title -no-bottom">
          {{ $t('common.navigation.aboutUs') }}
        </h2>
      </div>

      <p v-appear="{ delay: 200 }">{{ $t('home.about.content') }}</p>
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutTeam'
}
</script>
